module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1fm"
  }, [_c('span', {
    attrs: {
      "aria-label": "page viii",
      "epub:type": "pagebreak",
      "id": "page_viii",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "page ix",
      "epub:type": "pagebreak",
      "id": "page_ix",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is a work of satirical fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Names, characters, places, and events are either the product of the author’s imagination or used in a fictitious manner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Any person finding any resemblance between themselves and persons depicted herein should probably be ashamed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-345552bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781982157487/xhtml/authornote.vue
// module id = 69
// module chunks = 0